module.exports = __webpack_public_path__ + "46e48ce0628835f68a7369d0254e4283.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/materialize-css/dist/fonts/roboto/Roboto-Light.ttf
// module id = 70
// module chunks = 0